import "./LabelPrinting.scss";

export default function LabelPrinting() {
  return (
    <section className="sales-layout__page label-printing">
      <h1>Etiketten drucken</h1>
      <p>Hier werden zukünftig Etiketten gedruckt.</p>
    </section>
  );
}
